import { isSome, Maybe } from '@crocodille/util';
import { restaurantRoute } from '@routing';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@components/elements/card/card';
import cn from 'classnames';

import styles from './restaurant-card.module.scss';

export const RestaurantCardGrid: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <div className={styles.grid}>{children}</div>;
};

interface RestaurantCardProps {
  readonly name: string;
  readonly address: string;
  readonly openFrom: Maybe<string>;
  readonly openTo: Maybe<string>;
  readonly deliveryFrom: Maybe<string>;
  readonly deliveryTo: Maybe<string>;
  readonly small?: boolean;
  readonly imageSrc?: Maybe<string>;
  readonly code: string;
}

const RestaurantCard: React.FC<RestaurantCardProps> = ({
  name,
  address,
  openFrom,
  openTo,
  deliveryFrom,
  deliveryTo,
  small = false,
  imageSrc,
  code,
}) => {
  const { t } = useTranslation('restaurants');
  const addressWithoutPostcode = address.replace(/,\s*\d{5}$/, '').trim();

  return (
    <Card
      link={restaurantRoute(code)}
      imageSrc={imageSrc}
      name={name}
      small={small}
      smallImage
    >
      <div className={cn(styles.container, { [styles.small]: small })}>
        <h3>{name}</h3>
        <p className={styles.address}>{addressWithoutPostcode}</p>
        <p className={styles.openingHours}>
          {isSome(openFrom) && isSome(openTo)
            ? t('branch.open_from_to', { from: openFrom, to: openTo })
            : t('branch.closed')}
        </p>
        <p className={styles.deliveryHours}>
          {isSome(deliveryFrom) && isSome(deliveryTo)
            ? t('branch.delivery_from_to', {
                from: deliveryFrom,
                to: deliveryTo,
              })
            : t('branch.closed_delivery')}
        </p>
      </div>
    </Card>
  );
};

export default RestaurantCard;
